<template>
	<div>
		<spinner v-if="documents.loading" class="spinner"/>
		<div v-else class="documents-wrapper">
			<button @click="handleCloseEvent" class="back mobile btn btn-small btn-round">Back</button>
			<div class="documents">
				<medical-document v-for="document in documents.data" :key="document.id" :user_uid="user_uid" :watch_id="watch_id" :document="document" @delete="handleDeleteEvent"/>
			</div>
			<div v-if="!documents.data.length" class="no-documents">{{ $t('base.general.no_document') }}</div>
		</div>
	</div>
</template>

<script>
import MedicalDocument from './MedicalDocument'
export default {
	components: {
		MedicalDocument
	},
	props: [
		'user_uid',
		'watch_id',
		'category_id'
	],
	data () {
		return {
			documents: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	watch: {
		'$route' (to, from) {
			if (to.fullPath !== from.fullPath) {
				this.getDocuments()
			}
		}
	},
	methods: {
		handleCloseEvent () {
			this.$emit('input', null)
			this.$router.push({ name: 'WatchMedicalDocuments', params: { user_uid: this.user_uid, watch_id: this.watch_id } })
		},
		handleDeleteEvent () {
			this.$emit('delete')
			this.getDocuments()
		},
		getDocuments () {
			this.documents.loading = true
			this.$api.medicaldocuments.getAllByCategory(this, this.user_uid, this.watch_id, this.category_id).then(response => {
				this.$log.info('watch medicaldocuments', 'medicaldocuments.getAllByCategory OK', response)()
				this.documents.data = response.body
			}).catch(error => {
				this.$log.error('watch medicaldocuments', 'medicaldocuments.getAllByCategory ERROR', error)()
				this.documents.error = error
			}).finally(() => {
				this.documents.loading = false
			})
		},
	},
	mounted () {
		this.getDocuments()
		this.$root.$on('reload-medical-docs', this.getDocuments)
	},
	beforeDestroy () {
		this.$root.$off('reload-medical-docs', this.getDocuments)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/medicaldocuments/MedicalDocumentsView.vue